module.exports = __webpack_public_path__ + "img/github.bed61d0.png";